"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetrySyncDialog = TelemetrySyncDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var telemetry_1 = require("../../../features/apis/telemetry");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var hooks_1 = require("../../../store/hooks");
/*
 * The two utilities are not on the same schedule: power syncs every 30 minutes, water once a day at
 * midnight. The dialog used to claim "every 30 minutes" for both, which made a day of water readings
 * that simply had not synced yet look like a fault rather than something one press fixes.
 */
var AUTO_SYNC_CADENCE = {
    power: "Automatic syncs also run every 30 minutes.",
    water: "Automatic syncs run once a day at midnight, so readings taken today only arrive tonight.",
};
var MONTH_OPTIONS = [
    { key: "1", label: "January" },
    { key: "2", label: "February" },
    { key: "3", label: "March" },
    { key: "4", label: "April" },
    { key: "5", label: "May" },
    { key: "6", label: "June" },
    { key: "7", label: "July" },
    { key: "8", label: "August" },
    { key: "9", label: "September" },
    { key: "10", label: "October" },
    { key: "11", label: "November" },
    { key: "12", label: "December" },
];
var currentYear = new Date().getFullYear();
var YEAR_OPTIONS = Array.from({ length: currentYear - 2019 }, function (_, i) {
    var y = currentYear - i;
    return { key: String(y), label: String(y) };
});
function formatTimeRemaining(seconds) {
    if (seconds < 60)
        return "~".concat(Math.ceil(seconds), "s remaining");
    if (seconds < 3600)
        return "~".concat(Math.ceil(seconds / 60), " min remaining");
    var hours = Math.floor(seconds / 3600);
    var mins = Math.ceil((seconds % 3600) / 60);
    return "~".concat(hours, "h ").concat(mins, "m remaining");
}
function TelemetrySyncDialog(props) {
    var _this = this;
    var _a;
    var clientId = props.clientId, _b = props.initialMeterType, initialMeterType = _b === void 0 ? "power" : _b, _c = props.autoStart, autoStart = _c === void 0 ? false : _c;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _d = (0, react_3.useState)(initialMeterType), meterType = _d[0], setMeterType = _d[1];
    var _e = (0, react_3.useState)("sync"), syncMode = _e[0], setSyncMode = _e[1];
    var _f = (0, react_3.useState)(""), startDate = _f[0], setStartDate = _f[1];
    var _g = (0, react_3.useState)(String(new Date().getMonth() + 1)), fetchMonth = _g[0], setFetchMonth = _g[1];
    var _h = (0, react_3.useState)(String(new Date().getFullYear())), fetchYear = _h[0], setFetchYear = _h[1];
    var _j = (0, react_3.useState)("form"), syncState = _j[0], setSyncState = _j[1];
    var _k = (0, react_3.useState)(0), progress = _k[0], setProgress = _k[1];
    var _l = (0, react_3.useState)(""), statusMessage = _l[0], setStatusMessage = _l[1];
    var _m = (0, react_3.useState)(), estimatedTime = _m[0], setEstimatedTime = _m[1];
    var pollRef = (0, react_3.useRef)(null);
    var isResumingRef = (0, react_3.useRef)(false);
    var pollFailCountRef = (0, react_3.useRef)(0);
    var activeMeterTypeRef = (0, react_3.useRef)(initialMeterType);
    var autoStartedRef = (0, react_3.useRef)(false);
    // Power endpoints
    var syncTelemetry = (0, telemetry_1.useSyncTelemetryMutation)()[0];
    var historicBackfill = (0, telemetry_1.useHistoricBackfillMutation)()[0];
    var fetchMonthMutation = (0, telemetry_1.useFetchMonthMutation)()[0];
    var fetchPowerSyncStatus = (0, telemetry_1.useLazyFetchSyncStatusQuery)()[0];
    // Water endpoints
    var waterSync = (0, telemetry_1.useWaterSyncMutation)()[0];
    var waterHistoricBackfill = (0, telemetry_1.useWaterHistoricBackfillMutation)()[0];
    var waterFetchMonth = (0, telemetry_1.useWaterFetchMonthMutation)()[0];
    var fetchWaterSyncStatus = (0, telemetry_1.useLazyFetchWaterSyncStatusQuery)()[0];
    var fetchStatusForType = function (type) {
        return type === "power" ? fetchPowerSyncStatus({ clientId: clientId }) : fetchWaterSyncStatus({ clientId: clientId });
    };
    var meterLabel = meterType === "power" ? "Power" : "Water";
    var stopPolling = function () {
        if (pollRef.current) {
            clearInterval(pollRef.current);
            pollRef.current = null;
        }
    };
    // On mount, check both power and water for in-progress syncs
    (0, react_3.useEffect)(function () {
        var checkStatus = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var result, status_1, terminalStates, isRunning, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetchStatusForType(type).unwrap()];
                    case 1:
                        result = _d.sent();
                        status_1 = result === null || result === void 0 ? void 0 : result.content;
                        if (!status_1)
                            return [2 /*return*/, false];
                        terminalStates = ["idle", "completed", "failed", "error"];
                        isRunning = !terminalStates.includes(status_1.status);
                        if (isRunning) {
                            isResumingRef.current = true;
                            activeMeterTypeRef.current = type;
                            setMeterType(type);
                            setProgress((_b = status_1.progress) !== null && _b !== void 0 ? _b : 0);
                            setStatusMessage((_c = status_1.message) !== null && _c !== void 0 ? _c : "Processing...");
                            setEstimatedTime(status_1.estimatedTimeRemaining);
                            setSyncState("syncing");
                            startPolling(type);
                            return [2 /*return*/, true];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _d.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        }); };
        /*
         * Check for a sync already in flight before starting one. When the dialog was opened from a card
         * button (autoStart), resuming an existing run takes priority — otherwise pressing the button
         * while last night's sync is still going would queue a second one against the same provider.
         */
        checkStatus("power")
            .then(function (found) { return (found ? true : checkStatus("water")); })
            .then(function (found) {
            if (found || !autoStart || autoStartedRef.current)
                return;
            autoStartedRef.current = true;
            void handleSubmit();
        });
        return function () { return stopPolling(); };
    }, []);
    var startPolling = function (type) {
        stopPolling();
        pollFailCountRef.current = 0;
        var pollType = type || activeMeterTypeRef.current;
        pollRef.current = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, status_2, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetchStatusForType(pollType).unwrap()];
                    case 1:
                        result = _d.sent();
                        status_2 = result === null || result === void 0 ? void 0 : result.content;
                        if (!status_2)
                            return [2 /*return*/];
                        pollFailCountRef.current = 0;
                        setProgress((_b = status_2.progress) !== null && _b !== void 0 ? _b : 0);
                        setStatusMessage((_c = status_2.message) !== null && _c !== void 0 ? _c : "Processing...");
                        setEstimatedTime(status_2.estimatedTimeRemaining);
                        if (status_2.status === "completed") {
                            setProgress(100);
                            setSyncState("completed");
                            setStatusMessage("Sync completed successfully!");
                            stopPolling();
                        }
                        else if (status_2.status === "failed" || status_2.status === "error") {
                            setSyncState("failed");
                            setStatusMessage(status_2.message || "Sync failed. Please try again.");
                            stopPolling();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _d.sent();
                        pollFailCountRef.current += 1;
                        if (pollFailCountRef.current >= 3) {
                            setSyncState("failed");
                            setStatusMessage("Lost connection to the sync process. The backend may no longer be running.");
                            stopPolling();
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 3000);
    };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, message;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (syncMode === "backfill" && !startDate) {
                        (0, react_1.addToast)({
                            title: "Validation Failed",
                            description: "Please select a start date for the historic backfill.",
                            color: "danger",
                        });
                        return [2 /*return*/];
                    }
                    activeMeterTypeRef.current = meterType;
                    // Immediately show progress view
                    setSyncState("syncing");
                    setProgress(0);
                    setStatusMessage(syncMode === "sync"
                        ? "Starting ".concat(meterLabel, " telemetry sync...")
                        : syncMode === "fetchMonth"
                            ? "Fetching ".concat(meterLabel, " \u2014 ").concat((_a = MONTH_OPTIONS.find(function (m) { return m.key === fetchMonth; })) === null || _a === void 0 ? void 0 : _a.label, " ").concat(fetchYear, "...")
                            : "Starting ".concat(meterLabel, " historic backfill..."));
                    startPolling(meterType);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 15, , 16]);
                    response = void 0;
                    if (!(meterType === "power")) return [3 /*break*/, 8];
                    if (!(syncMode === "sync")) return [3 /*break*/, 3];
                    return [4 /*yield*/, syncTelemetry({ clientId: clientId }).unwrap()];
                case 2:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 3:
                    if (!(syncMode === "fetchMonth")) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetchMonthMutation({ clientId: clientId, year: parseInt(fetchYear), month: parseInt(fetchMonth) }).unwrap()];
                case 4:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, historicBackfill({ clientId: clientId, startDate: startDate }).unwrap()];
                case 6:
                    response = _c.sent();
                    _c.label = 7;
                case 7: return [3 /*break*/, 14];
                case 8:
                    if (!(syncMode === "sync")) return [3 /*break*/, 10];
                    return [4 /*yield*/, waterSync({ clientId: clientId }).unwrap()];
                case 9:
                    response = _c.sent();
                    return [3 /*break*/, 14];
                case 10:
                    if (!(syncMode === "fetchMonth")) return [3 /*break*/, 12];
                    return [4 /*yield*/, waterFetchMonth({ clientId: clientId, year: parseInt(fetchYear), month: parseInt(fetchMonth) }).unwrap()];
                case 11:
                    response = _c.sent();
                    return [3 /*break*/, 14];
                case 12: return [4 /*yield*/, waterHistoricBackfill({ clientId: clientId, startDate: startDate }).unwrap()];
                case 13:
                    response = _c.sent();
                    _c.label = 14;
                case 14:
                    if (response.success) {
                        setStatusMessage(syncMode === "sync"
                            ? "".concat(meterLabel, " telemetry sync in progress...")
                            : syncMode === "fetchMonth"
                                ? "Fetching ".concat(meterLabel, " month data in progress...")
                                : "".concat(meterLabel, " historic backfill in progress..."));
                    }
                    else {
                        setSyncState("failed");
                        setStatusMessage(response.message || "Could not start ".concat(meterLabel, " telemetry sync."));
                        stopPolling();
                    }
                    return [3 /*break*/, 16];
                case 15:
                    error_1 = _c.sent();
                    message = ((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _b === void 0 ? void 0 : _b.message) || "An error occurred while starting the sync.";
                    setSyncState("failed");
                    setStatusMessage(message);
                    stopPolling();
                    return [3 /*break*/, 16];
                case 16: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        stopPolling();
        dispatch((0, content_dialog_1.closeContentDialogThunk)());
    };
    var handleDone = function () {
        stopPolling();
        dispatch((0, content_dialog_1.closeContentDialogThunk)());
        if (syncState === "completed") {
            (0, react_1.addToast)({
                title: "Sync Complete",
                description: "".concat(meterLabel, " telemetry data has been synced successfully."),
                color: "success",
            });
        }
    };
    // Progress / Completed / Failed view
    if (syncState !== "form") {
        var isRunning = syncState === "syncing";
        var isCompleted = syncState === "completed";
        var isFailed = syncState === "failed";
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-5 p-6", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: activeMeterTypeRef.current === "power" ? "warning" : "primary", children: activeMeterTypeRef.current === "power" ? "POWER" : "WATER" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-3 py-2", children: [isRunning && ((0, jsx_runtime_1.jsx)("div", { className: "flex h-16 w-16 items-center justify-center rounded-full bg-blue-50", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", className: "animate-spin text-3xl text-blue-600" }) })), isCompleted && ((0, jsx_runtime_1.jsx)("div", { className: "flex h-16 w-16 items-center justify-center rounded-full bg-green-50", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-circle-linear", className: "text-3xl text-green-600" }) })), isFailed && ((0, jsx_runtime_1.jsx)("div", { className: "flex h-16 w-16 items-center justify-center rounded-full bg-red-50", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-linear", className: "text-3xl text-red-600" }) })), (0, jsx_runtime_1.jsx)("h3", { className: "text-base font-semibold ".concat(isCompleted ? "text-green-700" : isFailed ? "text-red-700" : "text-gray-800"), children: isCompleted
                                        ? "Complete"
                                        : isFailed
                                            ? "Failed"
                                            : isResumingRef.current
                                                ? statusMessage
                                                : syncMode === "sync"
                                                    ? "Syncing ".concat(meterLabel, " Telemetry...")
                                                    : syncMode === "fetchMonth"
                                                        ? "Fetching ".concat(meterLabel, " \u2014 ").concat((_a = MONTH_OPTIONS.find(function (m) { return m.key === fetchMonth; })) === null || _a === void 0 ? void 0 : _a.label, " ").concat(fetchYear, "...")
                                                        : "Running ".concat(meterLabel, " Historic Backfill...") })] }), (0, jsx_runtime_1.jsx)(react_1.Progress, { "aria-label": "Sync progress", value: progress, color: isCompleted ? "success" : isFailed ? "danger" : "primary", isIndeterminate: isRunning && progress === 0, className: "w-full", size: "md", showValueLabel: progress > 0 }), (0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg border border-gray-100 bg-gray-50 p-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isRunning ? "solar:clock-circle-linear" : isCompleted ? "solar:check-read-linear" : "solar:danger-triangle-linear", className: "text-base ".concat(isRunning ? "text-blue-500" : isCompleted ? "text-green-500" : "text-red-500") }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-gray-700", children: statusMessage })] }), isRunning && estimatedTime != null && estimatedTime > 0 && (0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-xs text-gray-500", children: formatTimeRemaining(estimatedTime) })] }), isRunning && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-start gap-2 rounded-lg bg-blue-50 p-3", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:info-circle-linear", className: "mt-0.5 shrink-0 text-base text-blue-600" }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-blue-700", children: "This sync is running in the background. You can close this dialog and continue working \u2014 you'll receive a notification when it's complete." })] }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2 border-t border-gray-100 px-6 py-4", children: [isRunning && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "flat", color: "danger", onPress: function () {
                                        stopPolling();
                                        isResumingRef.current = false;
                                        setSyncState("form");
                                        setProgress(0);
                                        setStatusMessage("");
                                        setEstimatedTime(undefined);
                                    }, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:stop-circle-linear", className: "text-lg" }), children: "Stop" }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: handleCancel, children: "Close" })] })), (isCompleted || isFailed) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isFailed && ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: "flat", color: "primary", onPress: function () {
                                        setSyncState("form");
                                        setProgress(0);
                                        setStatusMessage("");
                                        setEstimatedTime(undefined);
                                    }, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:restart-linear", className: "text-lg" }), children: "Try Again" })), (0, jsx_runtime_1.jsx)(react_1.Button, { color: isCompleted ? "success" : "primary", onPress: handleDone, children: "Done" })] }))] })] }));
    }
    // Form view
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-5 p-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-start gap-2 rounded-lg bg-amber-50 p-3", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:info-circle-linear", className: "mt-0.5 shrink-0 text-base text-amber-600" }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-amber-700", children: "Syncs run in the background \u2014 you can close this dialog and continue working. You'll receive a notification when the sync is complete." })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: meterType === "power" ? "solid" : "flat", color: "warning", onPress: function () { return setMeterType("power"); }, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:bolt-linear", className: "text-lg" }), className: "flex-1", children: "Power" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: meterType === "water" ? "solid" : "flat", color: "primary", onPress: function () { return setMeterType("water"); }, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:water-linear", className: "text-lg" }), className: "flex-1", children: "Water" })] }), (0, jsx_runtime_1.jsxs)(react_1.RadioGroup, { label: "Sync Mode", value: syncMode, onValueChange: function (v) { return setSyncMode(v); }, children: [(0, jsx_runtime_1.jsx)(react_1.Radio, { value: "sync", description: "Triggers an immediate ".concat(meterLabel.toLowerCase(), " sync. ").concat(AUTO_SYNC_CADENCE[meterType]), children: "Sync Now" }), (0, jsx_runtime_1.jsx)(react_1.Radio, { value: "fetchMonth", description: "Fetches and processes ".concat(meterLabel.toLowerCase(), " telemetry for a specific calendar month."), children: "Fetch Month" }), (0, jsx_runtime_1.jsx)(react_1.Radio, { value: "backfill", description: "Imports all historic ".concat(meterLabel.toLowerCase(), " telemetry data from a start date. This can take hours or days depending on the range."), children: "Historic Backfill" })] }), syncMode === "fetchMonth" && ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-3", children: [(0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Month", variant: "bordered", listboxProps: { className: "max-h-[200px] overflow-auto" }, selectedKeys: new Set([fetchMonth]), onSelectionChange: function (keys) { return setFetchMonth(Array.from(keys)[0]); }, children: MONTH_OPTIONS.map(function (m) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: m.label }, m.key)); }) }), (0, jsx_runtime_1.jsx)(react_1.Select, { disableAnimation: true, label: "Year", variant: "bordered", listboxProps: { className: "max-h-[200px] overflow-auto" }, selectedKeys: new Set([fetchYear]), onSelectionChange: function (keys) { return setFetchYear(Array.from(keys)[0]); }, children: YEAR_OPTIONS.map(function (y) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, { children: y.label }, y.key)); }) })] })), syncMode === "backfill" && ((0, jsx_runtime_1.jsx)(react_1.Input, { type: "date", label: "Start Date", placeholder: "Select start date", value: startDate, onValueChange: setStartDate, variant: "bordered", isRequired: true, startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:calendar-linear", className: "text-gray-400" }) }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2 border-t border-gray-100 px-6 py-4", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: handleCancel, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: meterType === "power" ? "warning" : "primary", onPress: handleSubmit, children: syncMode === "sync" ? "Start ".concat(meterLabel, " Sync") : syncMode === "fetchMonth" ? "Fetch ".concat(meterLabel, " Month") : "Start ".concat(meterLabel, " Backfill") })] })] }));
}
